import React, { useEffect, useState } from 'react';
import './ContentEditor.scss';
import { PageContentResponse } from '../models/api';
import { getContents } from '../services/page.service';
import ContentEditor from './ContentEditor';
import LoadingSpinner from './LoadingSpinner';

type PageEditorProps = {
  pageReference: string;
  setMessage: (message: string) => void;
  setErrors: (errors: string[]) => void;
};
const PageEditor: React.FC<PageEditorProps> = ({
  pageReference,
  setMessage,
  setErrors
}) => {
  const [loading, setLoading] = useState(false);
  const [pageContents, setPageContents] = useState<PageContentResponse | null>(
    null
  );

  const getPageDetails = async () => {
    if (!!loading || !pageReference) {
      return;
    }
    setLoading(true);
    try {
      const [contentsResponse] = await Promise.all([
        getContents(pageReference)
      ]);
      if (contentsResponse.success && contentsResponse.data) {
        setPageContents(contentsResponse.data);
        setErrors([]);
      } else {
        setErrors(contentsResponse.errors);
      }
    } catch (error) {
      setErrors(['There was a problem loading the event']);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPageDetails().catch(console.error);
  }, [pageReference]);

  if (loading) {
    return <LoadingSpinner inline={true} />;
  }

  return (
    <>
      {pageContents && (
        <ContentEditor
          pageContents={pageContents}
          reference={pageReference}
          setMessage={(p) => setMessage(p)}
          setErrors={(p) => setErrors(p)}
        />
      )}
    </>
  );
};

export default PageEditor;
